import { PageActionType } from './page-action-type';
import { castArray } from 'lodash';

export interface UpdatePageErrorAction {
  errors: Error[];
  pageKey: string;
  type: PageActionType.UpdatePageError;
}

export const updatePageError = (
  pageKey: string,
  errors: Error | readonly Error[],
): UpdatePageErrorAction => ({
  errors: castArray(errors),
  pageKey,
  type: PageActionType.UpdatePageError,
});
